/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable prefer-const */
/* eslint-disable import/no-cycle */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import {
  categoryPageBreadcrumbClicked,
  categoryPageHeroSectionReadLessClicked,
  categoryPageHeroSectionReadMoreClicked,
  clickLoadMoreInGallerySf,
  clickOnProductBoxSf,
  clickToChangeGalleryFiltersSf,
  exposureEventForTests,
  galleryClickApplyFilter,
  galleryClickClearAllFilters,
  galleryClickFilter,
  galleryClickSortBy,
  sortGallerySf,
  clickAddToWishlistSf,
  clickRemoveFromWishlistSf,
  productAddedToWishlistSf,
  productRemovedFromWishlistSf,
} from '@wix/bi-logger-ec-sf/v2';
import {clickToViewPromotionalCardSfSrc10Evid876, viewGallerySf} from '@wix/bi-logger-stores-data/v2';
import {createSlotVeloAPIFactory} from '@wix/widget-plugins-ooi/velo';
import {ILink, RouterPrefix} from '@wix/wixstores-client-core';
import {
  AddToCartActionOption,
  APP_DEFINITION_ID,
  PageMap,
  StoresWidgetID,
} from '@wix/wixstores-client-core/dist/es/src/constants';
import {actualPrice, isPreOrder} from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
import {AddToCartService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/AddToCartService';
import {MultilingualService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/MultilingualService/MultilingualService';
import {ProductPriceBreakdown} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductPriceBreakdown/ProductPriceBreakdown';
import {ProductPriceRange} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/ProductPriceRange/ProductPriceRange';
import {CustomUrlApi} from '@wix/wixstores-client-storefront-sdk/dist/es/src/utils/CustomUrl/CustomUrlApi';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {getTranslations} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/utils';
import type {ControllerFlowAPI, ITrackEventName} from '@wix/yoshi-flow-editor';
import {DangerousPublicDataOverrideFn} from '@wix/yoshi-flow-editor-runtime/build/cjs/helpers/createDangerousPublicDataOverride';
import _ from 'lodash';
import {BreadcrumbsItem} from '@wix/wix-ui-tpa';
import {ConversionRateResponse, getConversionRate} from '../api/getConversionRate';
import {unitsTranslations} from '../common/components/ProductItem/ProductPrice/unitsTranslations';
import {getProductPageSectionUrl} from '../common/url/productPageUrl';
import categoryStylesParams from '../components/CategoryPage/stylesParams';
import gridGalleryStylesParams from '../components/GridGallery/stylesParams';
import searchModalPageStylesParams from '../components/SearchModalGallery/stylesParams';
import searchResultsPageStylesParams from '../components/SearchResultsPageGallery/stylesParams';
import {
  AddToCartActionStatus,
  BiEventParam,
  CategoryListLayout,
  CategoryListStrategy,
  DEFAULT_COLS,
  DEFAULT_MOBILE_PRODUCTS_COUNT,
  DEFAULT_ROWS,
  Experiments,
  FedopsInteraction,
  GallerySlotIds,
  STORES_CATEGORY_SEO,
  STORES_GALLERY_SEO,
  STORES_SUB_CATEGORY_SEO,
  TrackEvents,
  translationPath,
  widgetLoadedPanoramaEventMap,
} from '../constants';
import {GetCategoryInitialDataQuery, GetDataQuery} from '../graphql/queries-schema';
import {CategoriesData, CategoriesService} from '../services/CategoriesService';
import {FilterConfigsService} from '../services/filters/FilterConfigsService';
import {FiltersAnnouncerService} from '../services/filters/FiltersAnnouncerService';
import {FiltersService} from '../services/filters/FiltersService';
import {DefaultQueryParamKeys, GalleryQueryParamsService} from '../services/GalleryQueryParamsService';
import {ProductItemsService} from '../services/ProductItemsService';
import {ProductsService} from '../services/ProductsService';
import {SortService} from '../services/sort/SortService';
import {galleryColumnsDefaultValue, galleryRowsDefaultValue} from '../styleParams/baseStylesParams';
import {IRouterCategory} from '../types/category';
import {ExternalDataSourceConfig} from '../types/externalDataSourceConfig';
import {
  FilterModel,
  GridType,
  HoverType,
  IFilterConfigDTO,
  IFilterSelectionValue,
  IPromotion,
  IGalleryControllerConfig,
  IGetInitialData,
  ImageModeId,
  ImagePlacements,
  ImagePositions,
  ImageRatioId,
  IProduct,
  IProductGroup,
  IProductGroupAssignment,
  IPropsInjectedByViewerScript,
  ITextsMap,
  LoadMoreType,
  PaginationType,
  PaginationTypeName,
  ProductsManifest,
  SidePanelData,
  VeloInputs,
  ProductOptionsDisplayOption,
} from '../types/galleryTypes';

import {ISorting, ISortingOption} from '../types/sorting';
import {BaseGalleryStore} from './BaseGalleryStore';
import {ReportError} from './GalleryController';
import {getInitialProductsCountToFetch} from './utils';
import {generateComponentCollectionCacheKey, oldGenerateCacheKeySuffix} from '../services/warmUpDataUtils';
import {GallerySEOService} from '../services/GallerySEOService';
import {GalleryBIService} from '../services/GalleryBIService';
import {ViewerContext} from '@wix/wixstores-client-storefront-common';

export class GalleryStore extends BaseGalleryStore {
  private readonly panoramaClient: ControllerFlowAPI['panoramaClient'];
  private currentPage: number = 1;
  private scrollToProduct: string;
  private filterConfigsService: FilterConfigsService;
  private filtersService: FiltersService;
  private isFedopsReport: boolean = true;
  private multilingualService: MultilingualService;
  private categoriesService: CategoriesService;
  private productPageSectionUrl: string;
  private readonly productsPerPage: number;
  private readonly queryParamsService: GalleryQueryParamsService;
  private readonly filterAnnouncerService: FiltersAnnouncerService;
  private readonly fedopsLogger;
  private readonly sortService: SortService;
  private translations;
  private readonly customUrlApi: CustomUrlApi;
  private isUrlWithOverrides: boolean = false;
  private mainCollectionId: string = null;
  private currentCategory: IRouterCategory;
  private homepageUrl: string;
  private breadcrumbsItems: any[] = [];
  private taxonomicalBreadcrumbsItems: any[] = [];
  private isCategoryVisible: boolean = true;
  private galleryRows: number;
  private externalDataSourceConfig: ExternalDataSourceConfig;
  private isCatalogV3: boolean;
  private readonly componentCollectionCacheKey: string;
  private readonly oldCacheKeySuffix: string;
  private seoService: GallerySEOService;
  private biService: GalleryBIService;
  private promotions: IPromotion[] = [];
  private categoriesDataFetched = false;

  // eslint-disable-next-line @typescript-eslint/tslint/config
  constructor(
    config: IGalleryControllerConfig,
    dangerousPublicDataOverride: DangerousPublicDataOverrideFn,
    updateComponent: (props: Partial<IPropsInjectedByViewerScript>) => void,
    siteStore: SiteStore,
    viewerContext: ViewerContext,
    compId: string,
    type: string,
    flowAPI: ControllerFlowAPI,
    reportError: ReportError,
    slotAPIFactory: ReturnType<typeof createSlotVeloAPIFactory>,
    veloInputs?: VeloInputs
  ) {
    super(
      config,
      dangerousPublicDataOverride,
      siteStore,
      viewerContext,
      updateComponent,
      type,
      compId,
      flowAPI,
      reportError,
      slotAPIFactory,
      veloInputs
    );
    this.panoramaClient = this.flowAPI.panoramaClient;
    const shouldUseNewApplyFilterQueryParams =
      this.type === StoresWidgetID.SEARCH_RESULTS_GALLERY ||
      this.experiments.enabled(Experiments.UseGalleryNewApplyFilterQueryParams);
    this.queryParamsService = new GalleryQueryParamsService({
      siteStore: this.siteStore,
      isMobile: this.siteStore.isMobile(),
      isCategoryPage: this.isCategoryPage,
      usingMultiCollectionFilters: this.usingExtendedGridGalleryWidget,
      shouldUseNewApplyFilterQueryParams,
      experiments: this.experiments,
    });

    const fedopsLoggerFactory = this.siteStore.platformServices.fedOpsLoggerFactory;
    this.fedopsLogger = fedopsLoggerFactory.getLoggerForWidget({
      appId: APP_DEFINITION_ID,
      widgetId: this.type,
    });

    this.sortService = new SortService(this.type as StoresWidgetID, this.styles);

    this.addToCartService = new AddToCartService(this.siteStore, this.publicData);
    this.setGalleryRows();

    this.productItemsService = new ProductItemsService(this.updateComponent);

    this.componentCollectionCacheKey = generateComponentCollectionCacheKey(this.mainCollectionId, this.compId);
    this.oldCacheKeySuffix = oldGenerateCacheKeySuffix(
      this.siteStore.location.query,
      this.mainCollectionId,
      this.compId
    );

    this.productsService = new ProductsService(
      this.siteStore,
      this.viewerContext,
      this.biType,
      this.shouldShowProductOptions,
      this.shouldRenderPriceRange,
      this.fedopsLogger,
      this.panoramaClient,
      this.flowAPI.controllerConfig.wixCodeApi,
      this.componentCollectionCacheKey,
      this.oldCacheKeySuffix,
      this.productItemsService,
      this.experiments
    );
    this.productsPerPage = this.productsService.getProductPerPage();
    this.customUrlApi = new CustomUrlApi(this.siteStore.location.buildCustomizedUrl);
    this.filterAnnouncerService = new FiltersAnnouncerService({updateComponent});
  }

  private get isCategoryPage() {
    return this.type === StoresWidgetID.CATEGORY_PAGE;
  }

  private get usingExtendedGridGalleryWidget() {
    return [
      StoresWidgetID.CATEGORY_PAGE,
      StoresWidgetID.SEARCH_MODAL_GALLERY,
      StoresWidgetID.SEARCH_RESULTS_GALLERY,
    ].includes(this.type as StoresWidgetID);
  }

  private createSEOService(): GallerySEOService | undefined {
    if (this.experiments.enabled(Experiments.GalleryStoreExtractSEO)) {
      return new GallerySEOService({
        siteStore: this.siteStore,
        viewerContext: this.viewerContext,
        queryParamsService: this.queryParamsService,
        productsService: this.productsService,
        categoriesService: this.categoriesService,
        experiments: this.experiments,
      });
    }
  }

  private createBIService(): GalleryBIService | undefined {
    if (this.experiments.enabled(Experiments.GalleryStoreExtractBI)) {
      return new GalleryBIService({
        siteStore: this.siteStore,
        productsService: this.productsService,
        filtersService: this.filtersService,
        type: this.type,
      });
    }
  }

  private getFilterComponentProps() {
    return {
      filterModels: this.filtersService.getFilterModels(),
      hasSelectedFilters: this.hasSelectedFilters(),
      shouldShowClearFilters: this.shouldShowClearFilters(),
      numberOfSelectedFilterTypes: this.getNumberOfSelectedFilterTypes(),
    };
  }

  public getDataForSEOCarousel(shouldSendSubcategoriesSeoData: boolean) {
    if (!shouldSendSubcategoriesSeoData) {
      return [];
    }
    return this.productsService.products?.slice(0, 5).map((product, index) => {
      return {
        position: index + 1,
        name: product.name,
        price: product.price,
        url: this.getProductPageUrl(product.urlPart),
        image: product.media[0]?.fullUrl,
        currency: this.viewerContext.currency,
      };
    });
  }

  private renderCategorySEOTags() {
    const {prevUrl, nextUrl} = this.nextPrevLinksMapped();
    const shouldSendSubcategoriesSeoData = this.experiments.enabled(Experiments.SendSubcategoriesSeoDataSF);

    const categoryUrl = this.queryParamsService.getUrlWithCustomPageParamForSeo(this.currentPage);
    const itemType =
      this.currentCategory.parentCategoryId && shouldSendSubcategoriesSeoData
        ? STORES_SUB_CATEGORY_SEO
        : STORES_CATEGORY_SEO;

    const seoBreadcrumbsInput = this.currentCategory.breadcrumbsInfo?.breadcrumbs?.map((b) => ({
      name: b.categoryName,
      slug: b.categorySlug,
    }));

    const categorySeoData = this.categoriesService.getCategorySeoData(
      this.currentCategory.id,
      this.currentCategory.parentCategoryId,
      seoBreadcrumbsInput
    );

    let seoBreadcrumbs: {position: number; name: string; item: string}[] = [
      // eslint-disable-next-line sonarjs/no-duplicate-string
      {position: 1, name: this.translations['gallery.breadcrumbs.firstItem'], item: this.siteStore.location.baseUrl},
    ];
    categorySeoData.breadcrumbs && seoBreadcrumbs.push(...categorySeoData.breadcrumbs);
    seoBreadcrumbs.push({
      position: seoBreadcrumbs.length + 1,
      name: this.currentCategory.name,
      item: `${this.siteStore.location.baseUrl}/${RouterPrefix.CATEGORY}/${this.currentCategory.slug}`,
    });

    const products = this.getDataForSEOCarousel(shouldSendSubcategoriesSeoData);

    const breadcrumbsInfo = shouldSendSubcategoriesSeoData
      ? {
          breadcrumbs:
            this.currentCategory.breadcrumbsInfo?.breadcrumbs?.map((b) => ({
              categoryId: b.categoryId,
              categoryName: b.categoryName,
              categorySlug: b.categorySlug,
            })) ?? [],
        }
      : undefined;

    let category = shouldSendSubcategoriesSeoData
      ? {
          ...this.currentCategory,
          categoryUrl,
          image: this.currentCategory.media
            ? {
                url: this.currentCategory.media.fullUrl,
                width: this.currentCategory.media.width,
                height: this.currentCategory.media.height,
              }
            : undefined,
          itemCounter: this.currentCategory.numOfProducts,
          parentCategory: this.currentCategory.parentCategoryId
            ? {
                id: this.currentCategory.parentCategoryId,
                index: this.currentCategory.parentCategoryIndex,
              }
            : undefined,
          breadcrumbsInfo,
          pagination: {
            prevUrl,
            nextUrl,
            totalPages: this.totalPages,
            currentPage: this.currentPage,
          },
        }
      : {
          categoryUrl,
          categorySlug: this.currentCategory.slug,
          categoryName: this.currentCategory.name,
          categoryDesc: this.currentCategory.description,
          numberOfItems: this.productsService.totalCount,
          image: {
            imageUrl: this.currentCategory.media?.fullUrl,
            imageWidth: this.currentCategory.media?.width,
            imageHeight: this.currentCategory.media?.height,
            hasImage: !!this.currentCategory.media,
            imageAlt: this.currentCategory.name,
          },
          pagination: {
            prevUrl,
            nextUrl,
            totalPages: this.totalPages,
            currentPage: this.currentPage,
          },
        };

    const itemData = {
      products,
      category,
    };
    const seoData = this.currentCategory.seoData && JSON.parse(this.currentCategory.seoData);

    this.siteStore.seo.renderSEOTags({
      itemType,
      itemData,
      seoData,
    });
  }

  private renderGallerySEOTags() {
    const shouldSendSubcategoriesSeoData = this.experiments.enabled(Experiments.SendSubcategoriesSeoDataSF);
    const {prevUrl, nextUrl} = this.nextPrevLinksMapped();
    const url = this.queryParamsService.getUrlWithCustomPageParamForSeo(this.currentPage);
    const itemType = STORES_GALLERY_SEO;

    const products = this.getDataForSEOCarousel(shouldSendSubcategoriesSeoData);
    const itemData = {
      products,
      shop: {
        url,
      },
      pagination: {
        prevUrl,
        nextUrl,
        totalPages: this.totalPages,
        currentPage: this.currentPage,
      },
      items: {
        numberOfItems: this.productsService.totalCount,
      },
    };

    this.siteStore.seo.renderSEOTags({
      itemType,
      itemData,
    });
  }

  private navigateToFirstPage() {
    this.queryParamsService.moveToFirstPage();
  }

  private isStyleParamModified(styleParamName: string) {
    return !!this.config.style.styleParams?.numbers?.[styleParamName];
  }

  private get isGalleryRowsAndColsWereModified() {
    return this.isStyleParamModified('galleryRows') && this.isStyleParamModified('galleryColumns');
  }

  private get isFixedProductsCountModified(): boolean {
    return this.isStyleParamModified('gallery_fixedGridProductsCount');
  }

  private get shouldRenderPriceRange(): boolean {
    return new ProductPriceRange(this.siteStore).shouldShowPriceRange();
  }

  private get shouldShowImageCarousel(): boolean {
    const hoverType = this.getStyleParamByDevice(
      this.styles['mobile:gallery_imageEffect'],
      this.styles.gallery_hoverType
    );

    return (
      this.experiments.enabled(Experiments.GalleryProductItemCarouselHover) && hoverType.value === HoverType.Carousel
    );
  }

  public setVeloInputs(veloInputs: VeloInputs) {
    this.veloInputs = {
      ...this.veloInputs,
      ...veloInputs,
    };
  }

  public setExternalDataSourceConfig(externalDataSourceCallbacks: ExternalDataSourceConfig) {
    this.externalDataSourceConfig = externalDataSourceCallbacks;
    this.productsService.setExternalDataSourceGetProducts(externalDataSourceCallbacks.getProducts);
  }

  private getTranslation() {
    return this.translations
      ? Promise.resolve(this.translations)
      : getTranslations(translationPath(this.siteStore.baseUrls.galleryBaseUrl, this.viewerContext.locale));
  }

  private setGallerySlotsProps() {
    if (this.experiments.enabled(Experiments.RenderSlotsInGallery)) {
      const gallerySlotIds = Object.values(GallerySlotIds);
      for (const slotId of gallerySlotIds) {
        try {
          const slot = this.slotAPIFactory.getSlotAPI(slotId);
          slot.categoryId = this.mainCollectionId;
        } catch (e) {
          /* istanbul ignore next: nothing to test  */
          this.reportError(e);
        }
      }
    }
  }

  public async setInitialState(): Promise<any> {
    const {gallery_gridType, gallery_productsCount} = this.styles;
    const initialProductsCount = getInitialProductsCountToFetch({
      isMobile: this.siteStore.isMobile(),
      isEditor: this.siteStore.isEditorMode(),
      isAutoGrid: gallery_gridType === GridType.AUTO,
      rows: this.galleryRows,
      cols: this.galleryColumns,
      autoGridProductsCount: gallery_productsCount,
      isGalleryRowsAndColsWereModified: this.isGalleryRowsAndColsWereModified,
      isFixedProductsCountModified: this.isFixedProductsCountModified,
      externalProductsPerPage: this.externalProductsPerPage,
    });
    this.productsService.setProductsPerPage(initialProductsCount);
    this.isCategoryPage ? await this.setCategoryInitialState() : await this.setGalleryInitialState();
    this.setGallerySlotsProps();
  }

  private get galleryColumns() {
    /* istanbul ignore next: I think it will never reach DEFAULT_COLS, but i'm afraid to remove */
    return (
      this.styles.galleryColumns ??
      galleryColumnsDefaultValue({
        dimensions: this.config.dimensions,
        isMobile: this.siteStore.isMobile(),
      }) ??
      DEFAULT_COLS
    );
  }

  private setGalleryRows(shouldUpdateFixedProductsCount: boolean = false): void {
    if (this.isFixedProductsCountModified || shouldUpdateFixedProductsCount) {
      const styleParamProductsCount = this.styles.gallery_fixedGridProductsCount;
      this.galleryRows = styleParamProductsCount / this.galleryColumns;
      return;
    }

    this.galleryRows =
      this.styles.galleryRows ??
      galleryRowsDefaultValue({getStyleParamValue: () => this.galleryColumns}) ??
      /* istanbul ignore next: I think it will never reach DEFAULT_ROWS, but i'm afraid to remove */
      DEFAULT_ROWS;
  }

  private get externalProductsPerPage() {
    return this.externalDataSourceConfig?.productsPerPage;
  }

  private get maxProductsPerPage() {
    if (this.externalProductsPerPage) {
      return this.externalProductsPerPage;
    }
    const shouldUseMobileDefaults =
      this.siteStore.isMobile() &&
      !this.isGalleryRowsAndColsWereModified &&
      !this.isFixedProductsCountModified &&
      !this.config.usesCssPerBreakpoint;

    switch (true) {
      case this.shouldUseAutoGridProductsCount:
        return this.styles.gallery_productsCount;
      case shouldUseMobileDefaults:
        return DEFAULT_MOBILE_PRODUCTS_COUNT;
      default:
        return this.galleryColumns * this.galleryRows;
    }
  }

  private get totalPages() {
    return Math.ceil(this.productsService.totalCount / this.maxProductsPerPage);
  }

  private get productsLimit() {
    let limit: number;

    if (this.isAutoGrid()) {
      limit = this.styles.gallery_productsCount;
    }

    if (this.externalProductsPerPage) {
      limit = this.externalProductsPerPage;
    }

    if (this.siteStore.location.query.page) {
      limit = this.getProductsLimitByPageFromQueryParam(this.productsService.getProductPerPage());
    }

    return limit;
  }

  private createMultilingualService(widgetSettings: GetDataQuery['appSettings']['widgetSettings']) {
    return new MultilingualService(this.siteStore, this.publicData.COMPONENT, widgetSettings);
  }

  private createProductPriceBreakdownService() {
    return new ProductPriceBreakdown(this.siteStore, this.translations, {
      excludedPattern: 'gallery.price.tax.excludedParam.label',
      includedKey: 'gallery.price.tax.included.label',
      includedPattern: 'gallery.price.tax.includedParam.label',
      excludedKey: 'gallery.price.tax.excluded.label',
    });
  }

  private createFilterConfigsService(widgetSettings: GetDataQuery['appSettings']['widgetSettings']) {
    return new FilterConfigsService(
      widgetSettings.FILTERS,
      this.publicData.COMPONENT?.FILTERS?.data,
      this.styles,
      this.multilingualService,
      this.translations,
      this.isCategoryPage
    );
  }

  private createFiltersService(currencyRateResponse: ConversionRateResponse) {
    let conversionRate = 1;
    if (this.shouldQueryCurrencyRate) {
      const {value, decimalPlaces} = currencyRateResponse.data?.rate;
      conversionRate = parseFloat(value) / Math.pow(10, decimalPlaces);
    }
    const currencyFormatter = this.flowAPI.getCurrencyFormatter({maximumFractionDigits: 0});

    return new FiltersService({
      siteStore: this.siteStore,
      mainCollectionId: this.mainCollectionId,
      filterConfigsService: this.filterConfigsService,
      allProductsCategoryId: this.productsService.allProductsCategoryId,
      formatCurrency: currencyFormatter,
      currency: this.viewerContext.getCurrentCurrency(),
      conversionRate,
      usingMultiCollectionFilters: this.usingExtendedGridGalleryWidget,
      externalDataSourceFiltersApi: this.externalDataSourceConfig?.getFiltersMetadata,
      componentCollectionCacheKey: this.componentCollectionCacheKey,
      oldCacheKeySuffix: this.oldCacheKeySuffix,
      experiments: this.experiments,
    });
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  private async setGalleryInitialState() {
    let data: GetDataQuery, translations, sectionUrl, products, currencyRateResponse: ConversionRateResponse;

    this.currentPage =
      this.type === StoresWidgetID.SEARCH_MODAL_GALLERY ? 1 : this.queryParamsService.getPageQueryParam();
    this.scrollToProduct = this.queryParamsService.getScrollToProductQueryParam();

    const sorting: ISortingOption = this.getSortFromQueryParam();
    if (sorting) {
      this.sortService.setSelectedSort(sorting.id);
      this.productsService.updateSort(sorting);
    }

    const translationsPromise = this.getTranslation();
    const dataPromise = this.productsService.getInitialData(this.getInitialDataOptions(this.productsLimit));
    const sectionUrlPromise = this.siteStore.getSectionUrl(PageMap.PRODUCT);

    const promises = [translationsPromise, dataPromise, sectionUrlPromise];

    const defaultCurrency = this.viewerContext.currency;
    const currentCurrency = this.viewerContext.getCurrentCurrency();
    this.shouldQueryCurrencyRate &&
      promises.push(
        getConversionRate(
          this.flowAPI.httpClient,
          this.reportError,
          defaultCurrency,
          currentCurrency,
          this.errorHandler
        )
      );

    [translations, data, sectionUrl, currencyRateResponse] = await Promise.all(promises).catch(this.reportError);

    this.translations = translations;
    this.productPageSectionUrl = getProductPageSectionUrl(sectionUrl, this.siteStore.location.baseUrl);
    this.mainCollectionId = this.productsService.getMainCollectionId();
    this.isUrlWithOverrides = await this.customUrlApi.init(); // TODO: Why is it in Promise.all on Category and here not?
    this.isCategoryVisible = data.catalog.category.visible;
    this.isCatalogV3 = data.catalog.isCatalogV3;
    this.promotions = this.shouldUsePromotionCards() ? data.catalog.category.promotions || [] : [];

    products = data.catalog.category.productsWithMetaData.list;

    this.productPriceBreakdown = this.createProductPriceBreakdownService();
    this.multilingualService = this.createMultilingualService(data.appSettings.widgetSettings);
    this.filterConfigsService = this.createFilterConfigsService(data.appSettings.widgetSettings);

    this.filtersService = this.createFiltersService(currencyRateResponse);
    this.seoService = this.createSEOService();
    this.biService = this.createBIService();

    let filterModels: FilterModel[] | [] = [];
    if (this.shouldShowFilters()) {
      filterModels = await this.fetchFilters();

      filterModels = this.updateFiltersFromQueryParams(filterModels);
      this.productsService.updateFilters(this.filtersService.getFiltersDTO());

      if (this.filtersService.hasSelectedFilters()) {
        products = await this.getFilterProducts();
      }
    }

    if (this.loadMoreType() === LoadMoreType.PAGINATION && this.queryParamsService.getQueryParam('page')) {
      products = await this.loadProductsByPage(this.currentPage);
    }

    let isFirstPage = true;

    if (this.currentPage > 1) {
      isFirstPage = false;
    }
    await Promise.all([this.setProductItemSlotsProps(products), this.loadUserWishlistProductIds()]);

    if (this.seoService) {
      this.seoService.renderGallerySEOTags({
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        maxProductsPerPage: this.maxProductsPerPage,
        getProductPageUrl: (slug) => this.getProductPageUrl(slug),
      });
    } else {
      this.renderGallerySEOTags();
    }

    this.updateComponent({
      ...this.getPropsToInject(products, filterModels),
      isFirstPage,
    });

    if (!this.siteStore.isSSR()) {
      this.productsService.storeNavigation(this.siteStore.siteApis.currentPage.id);
    }

    await this.externalDataSourceConfig?.onGalleryRendered?.();
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  private async setCategoryInitialState() {
    let initialData: GetCategoryInitialDataQuery,
      translations,
      sectionUrl,
      isUrlWithOverrides,
      products,
      homePage: ILink,
      currencyRateResponse: ConversionRateResponse;

    this.currentPage = this.queryParamsService.getPageQueryParam();
    this.scrollToProduct = this.queryParamsService.getScrollToProductQueryParam();
    const routerData = this.siteStore.windowApis.getRouterPublicData<IRouterCategory>();

    const shouldSetSEOStatus404FT = this.experiments.enabled(Experiments.GallerySet404ForSeoWhenPageHasNoProducts);

    const translationPromise = this.getTranslation();
    const withCategories = this.isTrueInAnyBreakpoint((bpStyle) => bpStyle.gallery_showCategories);
    this.categoriesDataFetched = withCategories;
    const categoryInitialDataPromise = this.productsService.getCategoryInitialData(
      this.config.externalId,
      routerData?.id,
      withCategories
    );
    const getSectionUrlPromise = this.siteStore.getSectionUrl(PageMap.PRODUCT);
    const getCustomUrlApiPromise = this.customUrlApi.init();
    const getHomepageLinkPromise = this.siteStore.getHomepageLink();

    const promises = [
      translationPromise,
      categoryInitialDataPromise,
      getSectionUrlPromise,
      getCustomUrlApiPromise,
      getHomepageLinkPromise,
    ];

    const defaultCurrency = this.viewerContext.currency;
    const currentCurrency = this.viewerContext.getCurrentCurrency();
    this.shouldQueryCurrencyRate &&
      promises.push(
        getConversionRate(
          this.flowAPI.httpClient,
          this.reportError,
          defaultCurrency,
          currentCurrency,
          this.errorHandler
        )
      );

    [translations, {data: initialData}, sectionUrl, isUrlWithOverrides, homePage, currencyRateResponse] =
      await Promise.all(promises).catch(this.reportError);

    this.isCatalogV3 = initialData.catalog.isCatalogV3;
    this.promotions = this.shouldUsePromotionCards() ? initialData.catalog.category?.promotions || [] : [];

    this.translations = translations;
    this.isUrlWithOverrides = isUrlWithOverrides;
    this.productPageSectionUrl = getProductPageSectionUrl(sectionUrl, this.siteStore.location.baseUrl);
    this.homepageUrl = homePage.url;

    this.multilingualService = this.createMultilingualService(initialData.appSettings.widgetSettings);
    this.productPriceBreakdown = this.createProductPriceBreakdownService();
    this.filterConfigsService = this.createFilterConfigsService(initialData.appSettings.widgetSettings);

    this.filtersService = this.createFiltersService(currencyRateResponse);
    this.categoriesService = this.initializeCategoriesService(initialData, routerData);
    this.seoService = this.createSEOService();
    this.biService = this.createBIService();

    const currentCategory = this.categoriesService.getProps().currentCategory;

    if (!currentCategory) {
      this.updateComponent({
        ...this.getEmptyStatePropsToInject(),
      });
      return null;
    }

    this.setCurrentCategory(currentCategory);

    const sorting: ISortingOption = this.getSortFromQueryParam();
    if (sorting) {
      this.sortService.setSelectedSort(sorting.id);
      this.productsService.updateSort(sorting);
    } else {
      this.sortService.setDefaultSortBySettings(this.styles.gallery_sortingDefaultOption.value);
      this.productsService.updateSort(this.sortService.getSelectedSort());
    }

    let filterModels: FilterModel[] = [];
    if (this.shouldShowFilters()) {
      const serverFilterModels = await this.filtersService.fetchFilters();
      filterModels = this.updateFiltersFromQueryParams(serverFilterModels);
      this.productsService.updateFilters(this.filtersService.getFiltersDTO());
    }

    if (this.siteStore.experiments.enabled(Experiments.GalleryFixOutOfBoundsPageParam)) {
      const totalPages = Math.ceil(this.currentCategory.numOfProducts / this.maxProductsPerPage);
      if (totalPages > 0 && this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }
    }

    if (this.loadMoreType() === LoadMoreType.PAGINATION && this.currentPage) {
      products = await this.loadProductsByPage(this.currentPage);
    } else {
      products = await this.getFilterProducts();
    }
    if (shouldSetSEOStatus404FT && this.siteStore.seo.isInSEO()) {
      if (this.seoService) {
        this.seoService.setAppropriateSEOPageCode(this.currentPage, this.maxProductsPerPage);
      } else {
        this.setAppropriateSEOPageCode();
      }
    }
    await Promise.all([this.setProductItemSlotsProps(products), this.loadUserWishlistProductIds()]);

    if (this.seoService) {
      this.seoService.renderCategorySEOTags({
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        maxProductsPerPage: this.maxProductsPerPage,
        getProductPageUrl: (slug) => this.getProductPageUrl(slug),
        currentCategory: this.currentCategory,
        translations: this.translations,
      });
    } else {
      this.renderCategorySEOTags();
    }

    this.updateComponent({
      ...this.getPropsToInject(products, filterModels),
      isFirstPage: this.currentPage <= 1,
    });

    if (!this.siteStore.isSSR()) {
      this.productsService.storeNavigation(this.siteStore.siteApis.currentPage.id);
    }
  }

  private async fetchCategoriesIfNeeded() {
    const shouldFetchCategories =
      this.isCategoryPage &&
      this.isTrueInAnyBreakpoint((bpStyle) => bpStyle.gallery_showCategories) &&
      !this.categoriesDataFetched;

    if (!shouldFetchCategories) {
      return;
    }

    const {data: initialData} = await this.productsService.getCategoryInitialData(
      this.config.externalId,
      this.currentCategory?.id,
      true
    );
    this.categoriesDataFetched = true;
    const routerData = this.siteStore.windowApis.getRouterPublicData<IRouterCategory>();
    this.categoriesService = this.initializeCategoriesService(initialData, routerData);
  }

  private initializeCategoriesService(initialData: GetCategoryInitialDataQuery, routerCategory?: IRouterCategory) {
    const {catalog} = initialData;
    const allCategories = catalog?.categories?.list ?? [];
    const allProductsCategoryId = catalog.allProductsCategoryId;

    const currentCategory = (routerCategory ?? allCategories.find((cat) => cat.visible)) as IRouterCategory;

    const categoriesService = new CategoriesService({
      currentCategory,
      allCategories,
      allProductsCategoryId,
      siteStore: this.siteStore,
      updateComponent: this.updateComponent,
    });

    categoriesService.updateVisibleCategories({
      categoryListConfig: initialData.appSettings.widgetSettings.CATEGORY_LIST_CONFIG as IFilterConfigDTO,
      shouldUseCategoryListConfig: this.styles.gallery_categoryListStrategy === CategoryListStrategy.MANUALLY,
    });

    return categoriesService;
  }

  private setAppropriateSEOPageCode() {
    const totalProducts = this.productsService.totalCount;
    const startIndex = (this.currentPage - 1) * this.maxProductsPerPage;
    const shouldSetSEOStatus404 = startIndex > totalProducts && totalProducts > 0;
    if (shouldSetSEOStatus404) {
      this.siteStore.seo.setSeoStatusCode(404);
    }
  }

  private getInitialDataOptions(limit: number): Omit<IGetInitialData, 'withOptions' | 'withPriceRange'> {
    let initialDataOptions = {
      externalId: this.config.externalId,
      compId: this.compId,
      filters: null,
      limit,
      offset: 0,
      mainCollectionId: this.mainCollectionId,
    };

    if (this.veloInputs?.collectionId) {
      initialDataOptions = {...initialDataOptions, mainCollectionId: this.veloInputs.collectionId};
    } else if (this.veloInputs?.productIds) {
      this.productsService.setVeloInputsProductIds(this.veloInputs.productIds);
      initialDataOptions = {
        ...initialDataOptions,
        mainCollectionId: this.productsService.allProductsCategoryId,
        filters: {
          term: {
            field: 'id',
            op: 'IN',
            values: this.veloInputs.productIds,
          },
        },
      };
    }
    return initialDataOptions;
  }

  public onAppLoaded(): void {
    /* istanbul ignore else */
    if (this.isFedopsReport) {
      this.isFedopsReport = false;

      /* istanbul ignore next: debug */
      if (this.experiments.enabled('specs.stores.ReportBiForEmptyGallery') && !this.productsService.products.length) {
        this.siteStore.webBiLogger.report(exposureEventForTests({testName: `empty-gallery-${this.type}`}));
      }

      if (this.biService) {
        const viewGallerySfParams = this.biService.getViewGallerySfParams({
          styles: this.styles,
          commonParams: super.commonViewGallerySfParams,
          commonSettingsParams: super.commonViewGallerySfSettingsParams,
          biType: this.biType,
          shouldShowProductOptions: this.shouldShowProductOptions,
          productsLogic: this.productsLogic,
          galleryColumns: this.galleryColumns,
          isAutoGrid: this.isAutoGrid(),
          isCategoryPage: this.isCategoryPage,
          currentCategory: this.currentCategory,
        });
        this.biService.sendViewGallerySfReport(viewGallerySfParams);
      } else {
        this.siteStore.webBiLogger.report(viewGallerySf(this.getViewGallerySfParams()));
      }
    }
  }

  private getViewCategoriesSfParams() {
    return {
      isCategoryPage: this.isCategoryPage,
      hasHeroImage: this.currentCategory?.media?.url && this.styles.gallery_showCategoryHeaderImage,
      hasHeroDescription: this.currentCategory?.description && this.styles.gallery_showCategoryHeaderDescription,
      hasProductCounter: this.styles.gallery_showProductsCounter,
      hasBreadcrumbs: this.styles.gallery_showCategoriesBreadcrumbs,
      hasCategoryTree: this.styles.gallery_showCategories,
    };
  }

  private getViewGallerySfParams() {
    const {galleryShowFilters, gallery_showAppliedFilters, galleryShowSort, gallery_productDropdownListWidth} =
      this.styles;

    const commonParams = super.commonViewGallerySfParams;
    const commonSettingsParams = super.commonViewGallerySfSettingsParams;

    let res = {
      ...commonParams,
      componentType: this.biType,
      filterType:
        (galleryShowFilters &&
          this.filtersService
            ?.getFilterModels()
            .map((m) => m.filterType)
            .join(',')) ||
        '',
      hasAppliedFilters: gallery_showAppliedFilters,
      hasOptions: this.shouldShowProductOptions,
      hasSorting: galleryShowSort,
      numOfColumns: this.isAutoGrid() ? undefined : this.galleryColumns,
      productsLogic: this.productsLogic,
      settings: JSON.stringify({
        ...commonSettingsParams,
        productDropdownListWidth: gallery_productDropdownListWidth,
      }),
    };
    if (this.isCategoryPage) {
      res = {...res, ...this.getViewCategoriesSfParams()};
    }
    return res;
  }

  private get productsLogic() {
    return this.mainCollectionId !== this.productsService.allProductsCategoryId ? 'collection' : 'All products';
  }

  private readonly shouldShowClearFilters = () => {
    if (this.siteStore.isMobile()) {
      return true;
    }
    const hasSelectedFilters = !!this.filtersService.getSelectedFilterTypes().length;

    if (this.isCategoryPage) {
      const appliedFiltersShown = this.styles.gallery_showAppliedFilters;
      return hasSelectedFilters && !appliedFiltersShown;
    }

    return hasSelectedFilters;
  };

  protected getProductsPageOffset(): number {
    return (this.currentPage - 1) * this.maxProductsPerPage;
  }

  protected getEmptyStatePropsToInject() {
    return {
      isCategoryVisible: this.isCategoryVisible,
      useCategories: this.useCategories,
      isCategoryPage: this.isCategoryPage,
      useSidePanel: this.useSidePanel,
      currentCategory: this.currentCategory,
      isEditorMode: this.siteStore.isEditorMode(),
      textsMap: this.getTextsMap(),
      onAppLoaded: this.onAppLoaded.bind(this),
      reportWidgetLoadedPanorama: this.reportWidgetLoadedPanorama,
      isFirstPage: true,
      productsRequestInProgress: false,
      isHorizontalLayout: this.isHorizontalLayout(),
      isInteractive: this.siteStore.isInteractive(),
      isLiveSiteMode: this.siteStore.isSiteMode(),
      isLoaded: true,
      experiments: this.getExperimentsToInject(),
      shouldShowMobile: this.siteStore.isMobile(),
      isPreviewMode: this.siteStore.isPreviewMode(),
      isRTL: this.siteStore.isRTL(),
      cssBaseUrl: this.siteStore.baseUrls.galleryBaseUrl,
      fitToContentHeight: true, // thunderbolt prop that sets height: auto on the widget instead of fixed height
      imagePosition: this.imagePosition(),
    };
  }

  protected getPropsToInject(
    products: IProduct[],
    filterModels: FilterModel[] | []
  ): Partial<IPropsInjectedByViewerScript> {
    return {
      ...this.getComputedProps(products),
      ...super.getCommonPropsToInject(),
      isCategoryVisible: this.isCategoryVisible,
      isEditorMode: this.siteStore.isEditorMode(),
      instanceId: this.siteStore.instanceManager.getInstance(),
      fitToContentHeight: true, // thunderbolt prop that sets height: auto on the widget instead of fixed height
      addedToCartStatus: this.addedToCartStatus,
      allowFreeProducts: this.addToCartService.allowFreeProducts,
      applyFilteredProductsOnMobile: this.applyFilteredProductsOnMobile.bind(this),
      clearFilters: this.clearFilters.bind(this),
      cssBaseUrl: this.siteStore.baseUrls.galleryBaseUrl,
      linkForAllPages: this.seoService
        ? this.seoService.getLinksForAllPages(this.totalPages)
        : this.getLinksForAllPages(),
      nextPrevLinks: this.seoService
        ? this.seoService.nextPrevLinks(this.currentPage, this.totalPages)
        : this.nextPrevLinks(),
      totalPages: this.totalPages,
      maxProductsPerPage: this.maxProductsPerPage,
      filterModels,
      filterProducts: this.onFilterChange.bind(this),
      handleAddToCart: this.handleAddToCart.bind(this),
      sendSortClickBiEvent: this.biService
        ? this.biService.sendSortClickBiEvent.bind(this.biService)
        : this.sendSortClickBiEvent.bind(this),
      handlePagination: this.handlePagination.bind(this),
      handleProductItemClick: this.handleProductItemClick.bind(this),
      reportProductItemClick: this.reportProductItemClick.bind(this),
      handlePromotionItemClick: this.handlePromotionItemClick.bind(this),
      reportRenderedPromotionImpressions: this.reportRenderedPromotionImpressions.bind(this),
      handleCategoryBreadcrumbsClick: this.biService
        ? this.biService.handleCategoryBreadcrumbsClick.bind(this.biService)
        : this.handleCategoryBreadcrumbsClick.bind(this),
      handleCategoryClampClick: this.biService
        ? this.biService.handleCategoryClampClick.bind(this.biService)
        : this.handleCategoryClampClick.bind(this),
      hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
      hasSelectedFilters: this.hasSelectedFilters(),
      imagePosition: this.imagePosition(),
      isAutoGrid: this.isAutoGrid(),
      isCategoryPage: this.isCategoryPage,
      isFirstPage: true,
      isHorizontalLayout: this.isHorizontalLayout(),
      isInteractive: this.siteStore.isInteractive(),
      isLiveSiteMode: this.siteStore.isSiteMode(),
      isLoaded: true,
      shouldShowMobile: this.siteStore.isMobile(),
      isPreviewMode: this.siteStore.isPreviewMode(),
      isRTL: this.siteStore.isRTL(),
      isSSR: this.siteStore.isSSR(),
      isMobileOnDesktopMode: this.queryParamsService.getIsMobileOnDesktopModeQueryParam() === 'true',
      isCatalogV3: this.isCatalogV3,
      loadMoreProducts: this.loadMoreProducts.bind(this),
      loadMoreType: this.loadMoreType(),
      mainCollectionId: this.mainCollectionId,
      numberOfSelectedFilterTypes: this.getNumberOfSelectedFilterTypes(),
      onAppLoaded: this.onAppLoaded.bind(this),
      reportWidgetLoadedPanorama: this.reportWidgetLoadedPanorama,
      openQuickView: this.openQuickView.bind(this),
      paginationMode: this.getPaginationMode(),
      selectedSort: this.sortService.getSelectedSort(),
      shouldAlternateImagePosition: this.shouldAlternateImagePosition(),
      shouldShowAddToCartSuccessAnimation: this.getAddToCartAction() === AddToCartActionOption.NONE,
      shouldShowClearFilters: this.shouldShowClearFilters(),
      shouldShowMobileFiltersModal: false,
      hasActiveSortOption: this.hasActiveSortOption(),
      shouldShowProductOptions: this.shouldShowProductOptions,
      showShowLightEmptyState: this.productsService.hideGallery,
      shouldUseAutoGridProductsCount: this.shouldUseAutoGridProductsCount,
      sortProducts: this.onSortChange.bind(this),
      sortingOptions: this.sortService.updateVisibleSortingOptions(this.styles),
      hasFilters: this.hasFilters(),
      textsMap: this.getTextsMap(),
      toggleFiltersModalVisibility: this.toggleFiltersModalVisibility.bind(this),
      totalProducts: this.productsService.totalCount,
      usingExtendedGridGalleryStyles: this.usingExtendedGridGalleryWidget,
      experiments: this.getExperimentsToInject(),
      handleProductsOptionsChange: this.handleOptionSelectionsChange.bind(this),
      productGroupsMap: this.productGroupsMap,
      handleCombinedListingSiblingSwitch: this.handleCombinedListingSiblingSwitch.bind(this),
      openQuickAddSlotIndex: null,
      unselectedOptionErrorSlotIndex: null,
      addToCartInProgressSlotIndex: null,
      productsRequestInProgress: false,
      currentCategory: this.currentCategory,
      breadcrumbsHistory: this.breadcrumbsItems,
      taxonomicalBreadcrumbs: this.taxonomicalBreadcrumbsItems,
      allProductsCategoryId: this.productsService.allProductsCategoryId,
      categories: this.categories,
      useCategories: this.useCategories,
      useSidePanel: this.useSidePanel,
      useFiltersAnnouncer: this.filterAnnouncerService.getProps(),
      navigateToFirstPage: this.navigateToFirstPage.bind(this),
      viewState: this.viewState,
    };
  }

  private get useCategories(): CategoriesData {
    if (this.categoriesService) {
      return this.categoriesService.getProps();
    }

    return {} as CategoriesData;
  }

  private get useSidePanel(): SidePanelData {
    const isDesktop = !this.siteStore.isMobile();
    const verticalCategoryList = this.styles.gallery_categoryListLayout === CategoryListLayout.Vertical && isDesktop;
    const hasFiltersContent =
      this.filtersService.getFilterModels().length > 0 &&
      (this.hasSelectedFilters() || this.productsService.totalCount > 0);

    const hasCategoriesContent = this.isCategoryPage && verticalCategoryList && !!this.categories.length;
    const shouldRenderSidePanel = isDesktop && (hasCategoriesContent || hasFiltersContent);

    return {shouldRenderSidePanel, hasFiltersContent, hasCategoriesContent};
  }

  private getExperimentsToInject() {
    return {
      shouldRenderGalleryProductItemCarouselHover: this.experiments.enabled(
        Experiments.GalleryProductItemCarouselHover
      ),
      isAllowGalleryProductRoundCornersInViewer: this.experiments.enabled(
        Experiments.AllowGalleryProductRoundCornersInViewer
      ),
      editableGridTemplateRepeatOption: this.experiments.enabled(Experiments.EditableGridTemplateRepeatOption),
      shouldRenderSlotsInGallery: this.experiments.enabled(Experiments.RenderSlotsInGallery),
    };
  }

  private getTextsMap(): ITextsMap {
    return {
      addToCartContactSeller: this.translations['gallery.contactSeller.button'],
      addToCartOutOfStock:
        this.multilingualService.get('gallery_oosButtonText') || this.translations['gallery.outOfStock.button'],
      addToCartSuccessSR: this.translations['gallery.sr.addToCartSuccess'],
      allCollectionsFilterButtonText: this.translations['filter.CATEGORY_ALL'],
      clearFiltersButtonText: this.translations['filter.CLEAN_ALL'],
      digitalProductBadgeAriaLabelText: this.translations['sr.digitalProduct'],
      galleryAddToCartButtonText:
        this.multilingualService.get('gallery_addToCartText') || this.translations['gallery.addToCart.button'],
      galleryAddToCartPreOrderButtonText:
        this.multilingualService.get('gallery_preOrderText') || this.translations['gallery.preOrder.button'],
      galleryRegionSR: this.translations['sr.region.GALLERY'],
      filtersSubmitButtonText: this.translations['gallery.mobile.filters.buttonApply'],
      filtersTitleText: this.multilingualService.get('FILTERS_MAIN_TITLE') || this.translations['filter.MAIN_TITLE'],
      filtersAriaLabel: this.translations['gallery.mobile.filters.buttonClose'],
      loadMoreButtonText: this.multilingualService.get('LOAD_MORE_BUTTON') || this.translations.LOAD_MORE_BUTTON,
      loadPreviousButtonText:
        this.multilingualService.get('gallery_loadPreviousText') || this.translations['gallery.loadPrevious.button'],
      mobileFiltersButtonText: this.translations['gallery.mobile.filters.title.button'],
      mobileFiltersAndSortingCustomButtonText:
        this.multilingualService.get('gallery_filtersAndSortMobileButtonText') || '',
      mobileFiltersAndSortingDefaultButtonText: this.translations['gallery.mobile.filterAndSort.defaultText'],
      mobileFiltersDefaultButtonText: this.translations['gallery.mobile.filter.defaultText'],
      mobileSortDefaultButtonText: this.translations['gallery.mobile.sort.defaultText'],
      sortByText: this.translations['gallery.sortBy.label.defaultText'],
      noProductsFilteredMessageText: this.translations.NO_PRODUCTS_FILTERED_MESSAGE_MAIN,
      noProductsMessageText: this.translations.NO_PRODUCTS_MESSAGE_MAIN,
      sortOptionNewestText: this.translations['sort.NEWEST'],
      sortOptionLowPriceText: this.translations['sort.PRICE_LOW'],
      sortOptionHighPriceText: this.translations['sort.PRICE_HIGH'],
      sortOptionNameAZText: this.translations['sort.NAME_AZ'],
      sortOptionNameZAText: this.translations['sort.NAME_ZA'],
      sortMostRelevantText: this.translations['gallery.sortingOptions.bestMatch.option'],
      sortTitleText: this.multilingualService.get('SORTING_MAIN_TITLE') || this.translations.SORT_BY,
      sortRecommendedText: this.translations['gallery.sortingOptions.recommended.option'],
      productOutOfStockText:
        this.multilingualService.get('gallery_oosButtonText') || this.translations.OUT_OF_STOCK_LABEL,
      productPriceBeforeDiscountSR: this.translations['sr.PRODUCT_PRICE_BEFORE_DISCOUNT'],
      productPriceAfterDiscountSR: this.translations['sr.PRODUCT_PRICE_AFTER_DISCOUNT'],
      productPriceWhenThereIsNoDiscountSR: this.translations['sr.PRODUCT_PRICE_WHEN_THERE_IS_NO_DISCOUNT'],
      quickViewButtonText: this.translations.QUICK_VIEW,
      quantityChooseAmountSR: this.translations['gallery.sr.chooseQty'],
      quantityInputSR: this.translations['gallery.sr.quantity'],
      announceFiltersUpdate: this.translations['sr.ANNOUNCE_FOUND_ITEMS_ON_FILTERS_UPDATE'],
      quantityMaximumAmountSR: this.translations['gallery.exceedsQuantity.error'],
      quantityTotalSR: this.translations['gallery.sr.totalQty'],
      quantityMinimumAmountSR: this.translations['gallery.minimumQuantity.error'],
      arrowPrevious: this.translations['gallery.sr.carousel.previous.label'],
      carouselContainerLabel: this.translations['gallery.sr.carousel.container.label'],
      arrowNext: this.translations['gallery.sr.carousel.next.label'],
      priceRangeText: this.translations['gallery.price.from.label'],
      pricePerUnitSR: this.translations['gallery.sr.units.basePrice.label'],
      measurementUnits: this.getMeasurementUnitsTranslation(),
      priceRangeMaxSR: this.translations['gallery.sr.filters.priceRange.max'],
      priceRangeMinSR: this.translations['gallery.sr.filters.priceRange.min'],
      productsCounterPlural: this.translations['gallery.numberOfProducts.label.plural'],
      productsCounterSingular: this.translations['gallery.numberOfProducts.label.singular'],
      productsCounterZero: this.translations['gallery.numberOfProducts.label.none'],
      sortLabel:
        this.multilingualService.get('SORTING_MAIN_TITLE') || this.translations['gallery.sortBy.label.defaultText'],
      categoryTreeTitle:
        this.multilingualService.get('categoryTreeTitle') || this.translations['gallery.categories.title.defaultText'],
      categoryHeaderReadMoreLink: this.translations['gallery.description.readMore.link'],
      categoryHeaderReadLessLink: this.translations['gallery.description.readLess.link'],
      emptyCategoryTitle: this.translations['gallery.emptyState.emptyCategory.title'],
      emptyCategoryBody: this.translations['gallery.emptyState.emptyCategory.body'],
      noFilterResultsTitle: this.translations['gallery.emptyState.noFilterResults.title'],
      noFilterResultsBody: this.translations['gallery.emptyState.noFilterResults.body'],
      noFilterResultsButton: this.translations['gallery.emptyState.noFilterResults.button'],
      emptyCategoryEditorTitle: this.translations['gallery.editor.emptyState.title'],
      emptyCategoryEditorSubTitle: this.translations['gallery.editor.emptyState.subtitle'],
      noCategories404Cta: this.translations['gallery.404NoCategories.emptyState.cta'],
      noCategories404Title: this.translations['gallery.404NoCategories.emptyState.text'],
      emptyCategoryPageEditorTitle:
        this.translations['gallery.categoryPage.editor.noVisibleCategories.emptyState.title'],
      emptyCategoryPageEditorSubtitle:
        this.translations['gallery.categoryPage.editor.noVisibleCategories.emptyState.body'],
      allProducts: this.translations['gallery.collection.allProducts'],
      categoryListShopAllButton: this.translations['gallery.categoryMenu.shopAll.text'],
      categoryListShowMore: this.translations['gallery.categoryMenu.showMore.text'],
      categoryListShowLess: this.translations['gallery.categoryMenu.showLess.text'],
      categoryFooterDescriptionShowMore:
        this.multilingualService.get('gallery_categoryFooterDescriptionShowMoreButtonText') ||
        this.translations['gallery.categoryMenu.showMore.text'],
      categoryFooterDescriptionShowLess:
        this.multilingualService.get('gallery_categoryFooterDescriptionShowLessButtonText') ||
        this.translations['gallery.categoryMenu.showLess.text'],
      appliedFiltersClearAllButton: this.translations['gallery.appliedFilters.clearAll.button'],
      appliedFiltersPriceTag: this.translations['gallery.appliedFilters.priceRange.tag'],
      appliedFiltersContainerSR: this.translations['gallery.sr.appliedFilters.container'],
      appliedFilterClearSR: this.translations['gallery.sr.appliedFilters.clearFilter.button'],
      colorSwatchNumChoicesLeftLabel: this.translations['gallery.colorSwatch.numChoicesLeft.label'],
      colorSwatchNumMoreOptionsAriaLabel: this.translations['gallery.colorSwatch.numMoreOptions.ariaLabel'],
      selectOptionsButtonText:
        this.multilingualService.get('gallery_selectOptionsButtonText') ||
        this.translations['gallery.selectOptions.button'],
      buttonOptionNumChoicesLeftLabel: this.translations['gallery.textChoices.numChoicesLeft.label'],
      buttonOptionNumMoreOptionsAriaLabel: this.translations['gallery.textChoices.numMoreOptions.ariaLabel'],
      quickAddAriaLabel: this.translations['gallery.addToCart.productOptions.quickAdd.sr.label'],
      quickAddDropdownSelect: this.translations['gallery.addToCart.productOptions.quickadd.sizeDropdown.select'],
      addToWishlistAriaLabel: this.translations['sr.gallery.layout.addWishlistButton'],
      removeFromWishlistAriaLabel: this.translations['sr.gallery.layout.removeWishlistButton'],
    };
  }

  private getLinksForAllPages(): string[] {
    /* istanbul ignore next: todo test */
    const numberOfPages = this.totalPages < 1000 ? this.totalPages : 1000;

    return _.times(numberOfPages, (i) => this.queryParamsService.getUrlWithCustomPageParamForSeo(i + 1));
  }

  private nextPrevLinksMapped(): {prevUrl: string; nextUrl: string} {
    const res = {prevUrl: '', nextUrl: ''};
    const prevIndex = this.currentPage - 1;
    const nextIndex = this.currentPage + 1;

    if (prevIndex > 0) {
      res.prevUrl = this.queryParamsService.getUrlWithCustomPageParamForSeo(prevIndex);
    }

    if (nextIndex <= this.totalPages) {
      res.nextUrl = this.queryParamsService.getUrlWithCustomPageParamForSeo(nextIndex);
    }

    return res;
  }

  private nextPrevLinks(): string[] {
    const {prevUrl, nextUrl} = this.nextPrevLinksMapped();
    return [prevUrl, nextUrl].filter((url) => url);
  }

  private getMeasurementUnitsTranslation() {
    return _.reduce(
      unitsTranslations,
      (result, types, unit) => {
        result[unit] = result[unit] || {};
        _.each(types, (translationKey, type) => {
          result[unit][type] = this.translations[translationKey];
        });
        return result;
      },
      {}
    );
  }

  private generateProductsManifest(products: IProduct[]): ProductsManifest {
    return products.reduce((acc: ProductsManifest, product) => {
      acc[product.id] = {
        url: this.getProductPageUrl(product.urlPart),
        addToCartState: this.addToCartService.getButtonState({
          price: actualPrice(product),
          inStock: product.isInStock,
          isPreOrderState: isPreOrder(product),
        }),
        productItemsState: this.productItemsService.calculateProductItemsState(product),
      };
      return acc;
    }, {});
  }

  private getProductPageUrl(slug) {
    return this.isUrlWithOverrides
      ? this.customUrlApi.buildProductPageUrl({slug})
      : `${this.productPageSectionUrl}/${slug}`;
  }

  private onFilterChange(filterId: number, selectionValue: IFilterSelectionValue) {
    const filterModel = this.filtersService.getFilterModel(filterId);
    this.filtersService.updateActiveFilterOption(filterModel, selectionValue);

    this.updateComponent(this.getFilterComponentProps());

    this.queryParamsService.updateFiltersQueryParams({
      filterModel,
      mainCollectionId: this.mainCollectionId,
    });

    this.siteStore.webBiLogger.report(
      clickToChangeGalleryFiltersSf({
        filterType: this.filtersService.getFilterModel(filterId).filterType,
      })
    );
  }

  private async filterProductsBySideEffect() {
    this.fedopsLogger.interactionStarted(FedopsInteraction.Filter);
    this.panoramaClient.transaction(FedopsInteraction.Filter).start();

    this.updateFiltersFromQueryParams(this.filtersService.getFilterModels(), true);
    this.productsService.updateFilters(this.filtersService.getFiltersDTO());
    this.updateComponent(this.getFilterComponentProps());
    this.filterAnnouncerService.setShouldAnnounceFilters(true);
    await this.updateComponentWithFilteredProducts();
    this.fedopsLogger.interactionEnded(FedopsInteraction.Filter);
    this.panoramaClient.transaction(FedopsInteraction.Filter).finish();
  }

  private setCurrentCategory(category: IRouterCategory) {
    this.currentCategory = category;
    this.mainCollectionId = this.currentCategory.id;
    this.productsService.setMainCollection(this.currentCategory.id);
    this.filtersService.setMainCollectionId(this.currentCategory.id);
    this.setBreadcrumbsHistory();
    this.setTaxonomicalBreadcrumbs();
  }

  private applyFilteredProductsOnMobile() {
    this.siteStore.webBiLogger.report(
      galleryClickApplyFilter({
        filterTypes: this.filtersService.getSelectedFilterTypes().toString(),
      })
    );

    this.updateComponent({
      numberOfSelectedFilterTypes: this.filtersService.getSelectedFilterOptionsCount(),
      shouldShowMobileFiltersModal: false,
    });
  }

  private async clearFilters() {
    this.filtersService.resetFilters();

    this.queryParamsService.clearAllFiltersQueryParams(this.queryParamsFilterKeys);

    this.siteStore.webBiLogger.report(galleryClickClearAllFilters({}));

    await this.updateComponentWithFilteredProducts();
  }

  private toggleFiltersModalVisibility(show: boolean) {
    if (show) {
      this.siteStore.webBiLogger.report(galleryClickFilter({}));
    }

    this.updateComponent({
      shouldShowMobileFiltersModal: show,
      filterModels: this.filtersService.getFilterModels(),
      hasSelectedFilters: this.hasSelectedFilters(),
    });
  }

  private async getFilterProducts() {
    const filterDTO = this.filtersService.getFiltersDTO();
    const shouldSpecificCollectionQuery = this.filtersService.shouldSpecificCollectionQuery(this.mainCollectionId);
    return this.productsService.filterProducts({
      filters: filterDTO,
      collectionIds: this.filtersService.getCollectionIdsFilterDTO(),
      shouldSpecificCollectionQuery,
      limit: this.productsLimit,
    });
  }

  private async updateComponentWithFilteredProducts() {
    const products = await this.getFilterProducts();
    if (this.externalDataSourceConfig?.facetedFilters) {
      await this.fetchFilters();
      this.updateFiltersFromQueryParams(this.filtersService.getFilterModels(), true);
      this.productsService.updateFilters(this.filtersService.getFiltersDTO());
    }
    await this.setProductItemSlotsProps(products);
    this.veloInputs?.onProductsChanged?.();
    this.updateComponent({
      ...this.getComputedProps(products),
      filterModels: this.filtersService.getFilterModels(),
      hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
      hasSelectedFilters: this.hasSelectedFilters(),
      shouldShowClearFilters: this.shouldShowClearFilters(),
      hasActiveSortOption: this.hasActiveSortOption(),
      currentCategory: this.currentCategory,
      breadcrumbsHistory: this.breadcrumbsItems,
      taxonomicalBreadcrumbs: this.taxonomicalBreadcrumbsItems,
      numberOfSelectedFilterTypes: this.getNumberOfSelectedFilterTypes(),
      useFiltersAnnouncer: this.filterAnnouncerService.getProps(),
    });
  }

  private hasSelectedFilters(): boolean {
    return this.filtersService.hasSelectedFilters();
  }

  private readonly loadMoreType = (): LoadMoreType => {
    return this.styles.gallery_loadMoreProductsType;
  };

  public updateAppOnQueryParamsChange({
    isPageUpdated,
    isFiltersUpdated,
    isSortUpdated,
  }: {
    isPageUpdated?: boolean;
    isFiltersUpdated?: boolean;
    isSortUpdated?: boolean;
  }) {
    const lastPage = this.currentPage;
    this.currentPage = this.queryParamsService.getPageQueryParam();
    if (isPageUpdated && (!isFiltersUpdated || !isSortUpdated)) {
      if (this.loadMoreType() === LoadMoreType.PAGINATION) {
        void this.handlePaginationBySideEffect();
      } else if (this.currentPage > lastPage) {
        void this.loadMoreProductsBySideEffect();
      }
    }
    if (isSortUpdated) {
      void this.sortProductsBySideEffect();
    }
    if (isFiltersUpdated) {
      void this.filterProductsBySideEffect();
    }
  }

  private async loadMoreProductsBySideEffect() {
    const visibleProducts = this.productsService.products.length;
    const fedopsInteraction =
      this.loadMoreType() === LoadMoreType.BUTTON ? FedopsInteraction.LoadMore : FedopsInteraction.InfiniteScroll;

    this.fedopsLogger.interactionStarted(fedopsInteraction);
    this.panoramaClient.transaction(fedopsInteraction).start();
    this.productsService.setProductsPerPage(this.maxProductsPerPage);

    const shouldSpecificCollectionQuery = this.filtersService.shouldSpecificCollectionQuery(this.mainCollectionId);
    const products = await this.productsService.loadMoreProducts({
      visibleProducts,
      shouldSpecificCollectionQuery,
    });
    if (products === null) {
      this.updateComponent({
        hasMoreProductsToLoad: false,
        productsRequestInProgress: false,
        isFirstPage: false,
      });
      return;
    }

    const focusedProductIndex = this.loadMoreType() === LoadMoreType.INFINITE ? -1 : visibleProducts;

    await this.setProductItemSlotsProps(products);
    this.veloInputs?.onProductsChanged?.();

    this.updateComponent({
      ...this.getComputedProps(products),
      focusedProductIndex,
      linkForAllPages: this.seoService
        ? this.seoService.getLinksForAllPages(this.totalPages)
        : this.getLinksForAllPages(),
      nextPrevLinks: this.seoService
        ? this.seoService.nextPrevLinks(this.currentPage, this.totalPages)
        : this.nextPrevLinks(),
      hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
      productsRequestInProgress: false,
    });

    this.fedopsLogger.interactionEnded(fedopsInteraction);
    this.panoramaClient.transaction(fedopsInteraction).finish();
  }

  private loadMoreProducts() {
    this.updateComponent({
      productsRequestInProgress: true,
    });
    const biCollection = this.biService ? this.biService.getBICollection() : this.getBICollection();
    this.siteStore.webBiLogger.report(
      clickLoadMoreInGallerySf({
        ...biCollection,
        type: this.loadMoreType() === LoadMoreType.BUTTON ? BiEventParam.LoadMore : BiEventParam.InfiniteScroll,
      })
    );
    this.queryParamsService.updatePageQueryParam(this.currentPage + 1);
  }

  private readonly hasOptions = (product: IProduct) => !!product.options.length;

  private async handleAddToCart({
    productId,
    index,
    quantity,
    isProductOptionsEnabled,
    isShowOnlyColorOptionsEnabled,
    isAddToCartFlowTypeIsQuickAdd,
    productOptionsDisplayOption,
  }: {
    productId: string;
    index: number;
    quantity: number;
    isProductOptionsEnabled: boolean;
    isShowOnlyColorOptionsEnabled: boolean;
    isAddToCartFlowTypeIsQuickAdd: boolean;
    productOptionsDisplayOption: ProductOptionsDisplayOption;
  }) {
    this.updateAddToCartStatus(productId, AddToCartActionStatus.IN_PROGRESS, index);

    const addToCartStatus = await this.productsService.addToCartFlow({
      productsManifest: this.productsManifest,
      addToCartAction: this.getAddToCartAction(),
      productId,
      index,
      quantity,
      compId: this.compId,
      externalId: this.config.externalId,
      isProductOptionsEnabled,
      isShowOnlyColorOptionsEnabled,
      isAddToCartFlowTypeIsQuickAdd,
      productOptionsDisplayOption,
    });

    if (!addToCartStatus) {
      return this.updateAddToCartStatus(productId, AddToCartActionStatus.IDLE);
    }

    return this.updateAddToCartStatus(productId, addToCartStatus, index);
  }

  private readonly getSortFromQueryParam = (): ISortingOption | undefined => {
    if (this.siteStore.location.query.sort) {
      return this.sortService.getSort(this.queryParamsService.getQueryParam('sort'));
    }
  };

  private readonly getProductsLimitByPageFromQueryParam = (productPerPage: number): number => {
    return parseInt(this.queryParamsService.getQueryParam(DefaultQueryParamKeys.Page), 10) * productPerPage;
  };

  /* istanbul ignore next: hard to test */
  public get queryParamsFilterKeys(): string[] {
    return this.filtersService.getFilterModels()?.map((f) => f.title);
  }

  private readonly updateFiltersFromQueryParams = (filterModels: FilterModel[], resetWhenEmpty = false) => {
    const queryParamsFilters = this.queryParamsService.getFiltersQueryParams(filterModels);
    if (queryParamsFilters) {
      this.filtersService.updateActiveFilterOptionsByQueryParams(queryParamsFilters);
    } else if (resetWhenEmpty) {
      this.filtersService.resetFilters();
    }

    return this.filtersService.getFilterModels();
  };

  private onSortChange(sorting: ISorting) {
    this.fedopsLogger.interactionStarted(FedopsInteraction.Sort);
    this.panoramaClient.transaction(FedopsInteraction.Sort).start();
    this.sortService.setSelectedSort(sorting.id);
    this.queryParamsService.updateSortQueryParams(sorting);
  }

  private async sortProductsBySideEffect() {
    const selectedSort = this.getSortFromQueryParam() ?? this.sortService.getDefaultSortingOption();
    this.productsService.updateSort(selectedSort);
    this.siteStore.webBiLogger.report(
      sortGallerySf({sortDir: selectedSort?.direction, method: selectedSort?.id.split('_')[0]})
    );
    const shouldSpecificCollectionQuery = this.filtersService.shouldSpecificCollectionQuery(this.mainCollectionId);
    const products = await this.productsService.sortProducts(
      selectedSort?.field ? selectedSort : null,
      shouldSpecificCollectionQuery
    );

    await this.setProductItemSlotsProps(products);
    this.veloInputs?.onProductsChanged?.();

    this.updateComponent({
      ...this.getComputedProps(products),
      hasMoreProductsToLoad: this.productsService.hasMoreProductsToLoad(),
      isFirstPage: false,
      selectedSort,
    });

    this.fedopsLogger.interactionEnded(FedopsInteraction.Sort);
    this.panoramaClient.transaction(FedopsInteraction.Sort).finish();
  }

  public refreshGallery() {
    const queryParamsActiveFilters = this.queryParamsService.getFiltersQueryParams(
      this.filtersService.getFilterModels()
    );

    if (queryParamsActiveFilters?.length > 0) {
      this.clearGalleryQueryParams();
    } else {
      this.updateAppOnQueryParamsChange({isFiltersUpdated: true});
    }
  }

  public clearGalleryQueryParams() {
    this.queryParamsService.clearAllQueryParams(this.queryParamsFilterKeys.map(encodeURIComponent));
  }

  private isHorizontalLayout() {
    const {gallery_imagePlacement, 'mobile:gallery_imagePlacement': mobileImagePlacement} = this.styles;
    const imagePlacement = this.getStyleParamByDevice(mobileImagePlacement, gallery_imagePlacement).value;

    return imagePlacement === ImagePlacements.HORIZONTAL;
  }

  private shouldAlternateImagePosition() {
    const {
      gallery_alternateImagePosition: desktopAlternateImagePosition,
      'mobile:gallery_alternateImagePosition': mobileAlternateImagePosition,
    } = this.styles;

    return this.getStyleParamByDevice(mobileAlternateImagePosition, desktopAlternateImagePosition);
  }

  private imagePosition(): ImagePositions {
    const {gallery_imagePosition: desktopImagePosition, 'mobile:gallery_imagePosition': mobileImagePosition} =
      this.styles;

    return this.getStyleParamByDevice<ImagePositions>(
      mobileImagePosition?.value as ImagePositions,
      desktopImagePosition?.value as ImagePositions
    );
  }

  protected get imageMode(): ImageModeId {
    const {gallery_imageMode: desktopImageMode, 'mobile:gallery_imageMode': mobileImageMode} = this.styles;

    return this.getStyleParamByDevice(mobileImageMode, desktopImageMode);
  }

  protected get imageRatio(): ImageRatioId {
    const {galleryImageRatio: desktopImageRatio, 'mobile:galleryImageRatio': mobileImageRatio} = this.styles;
    return this.getStyleParamByDevice(mobileImageRatio, desktopImageRatio);
  }

  private hasActiveSortOption() {
    const {
      gallerySortNewest,
      gallerySortPriceAsc,
      gallerySortPriceDes,
      gallerySortNameAsc,
      gallerySortNameDes,
      gallerySortRecommended,
    } = this.styles;

    const isAnySortActive =
      gallerySortNewest ||
      gallerySortPriceAsc ||
      gallerySortPriceDes ||
      gallerySortNameAsc ||
      gallerySortNameDes ||
      (this.isCategoryPage && gallerySortRecommended);

    return (
      isAnySortActive &&
      ((this.isCategoryPage && this.siteStore.isDesktop()) || this.productsService.products?.length > 0)
    );
  }

  private openQuickView({
    productId,
    index,
    selectionIds,
    quantity,
  }: {
    productId: string;
    index: number;
    selectionIds?: number[];
    quantity?: number;
  }) {
    this.productsService.quickViewProduct(productId, index, {
      compId: this.compId,
      externalId: this.config.externalId,
      selectionIds,
      quantity,
    });
  }

  protected reportProductItemClick({productId, index}: {productId: string; index: number}) {
    if (this.biService) {
      this.biService.reportProductItemClick({productId, index, productsLogic: this.productsLogic});
    } else {
      const product = this.productsService.getProduct(productId);
      this.siteStore.webBiLogger.report(
        clickOnProductBoxSf({
          productId,
          hasRibbon: !!product.ribbon,
          hasOptions: this.hasOptions(product),
          index,
          productType: product.productType,
          galleryType: this.type,
          galleryProductsLogic: this.productsLogic,
        })
      );
      this.productsService.sendClickTrackEvent(product, index);
    }
  }

  protected reportPromotionItemClick({promoId, index}: {promoId: string; index: number}) {
    if (this.biService) {
      this.biService.reportPromotionItemClick({promoId, index, productsLogic: this.productsLogic});
    } else {
      this.siteStore.webBiLogger.report(
        clickToViewPromotionalCardSfSrc10Evid876({
          promo_card_id: promoId,
          galleryType: this.type,
          galleryProductsLogic: this.productsLogic,
          index,
          ...this.getBICollection(),
        })
      );
    }
  }

  private handleProductItemClick({
    biData: {productId, index},
  }: {
    biData: {
      productId: string;
      index: number;
    };
  }) {
    const product = this.productsService.getProduct(productId);

    this.queryParamsService.updateScrollToProduct(product.urlPart);

    this.productsService.storeNavigation(this.siteStore.siteApis.currentPage.id);
    this.reportProductItemClick({productId, index});

    if (this.veloInputs?.onItemSelected) {
      this.veloInputs.onItemSelected.callBack(product.id, product, index);
      /* istanbul ignore next: WIP, having issues with spy on navigation. will be tested soon */
      if (this.veloInputs.onItemSelected.options.preventNavigation) {
        /* istanbul ignore next: WIP, having issues with spy on navigation. will be tested soon */
        return;
      }
    }

    this.siteStore.navigate(
      {
        sectionId: PageMap.PRODUCT,
        state: product.urlPart,
        queryParams: undefined,
      },
      true
    );
  }

  public reportRenderedPromotionImpressions(promotions: IPromotion[]) {
    if (this.siteStore.isSSR() || promotions.length === 0) {
      return;
    }

    this.siteStore.windowApis.trackEvent(
      TrackEvents.PromoCardImpression as ITrackEventName,
      {
        ...this.getPromotionTrackEventBaseData(),
        contents: promotions.map((promotion) => {
          return this.getPromotionTrackData(promotion);
        }),
      } as any
    );
  }

  private handlePromotionItemClick({promotion}: {promotion: IPromotion}) {
    const {promoId, promoName, categoryName, position} = this.getPromotionTrackData(promotion);
    const destinationUrl = promotion.promotion.destinationUrl;

    this.siteStore.windowApis.trackEvent(
      TrackEvents.ClickPromoCard as ITrackEventName,
      {
        ...this.getPromotionTrackEventBaseData(),
        categoryName,
        promoId,
        promoName,
        position,
        ctaUrl: destinationUrl,
      } as any
    );

    this.reportPromotionItemClick({promoId, index: position});
    this.siteStore.location.to(destinationUrl);
  }

  private getPromotionTrackData(promotion: IPromotion) {
    return {
      promoId: promotion.promotion.id,
      promoName: promotion.promotion.media?.image?.altText,
      categoryName: this.currentCategory?.name || this.productsService.collectionName,
      position: promotion.position,
    };
  }

  private getPromotionTrackEventBaseData() {
    return {
      appDefId: APP_DEFINITION_ID,
      origin: 'Stores',
    };
  }

  protected override reportWishlistActionStart(productId: string, shouldAdd: boolean): void {
    const fedopsInteraction = shouldAdd ? FedopsInteraction.AddToWishlist : FedopsInteraction.RemoveFromWishlist;

    this.fedopsLogger.interactionStarted(fedopsInteraction);
    this.panoramaClient.transaction(fedopsInteraction).start();

    const eventData = this.createWishlistBiEventData(productId);
    shouldAdd
      ? this.siteStore.webBiLogger.report(clickAddToWishlistSf(eventData))
      : this.siteStore.webBiLogger.report(clickRemoveFromWishlistSf(eventData));
  }

  protected override reportWishlistActionSuccess(productId: string, shouldAdd: boolean): void {
    const fedopsInteraction = shouldAdd ? FedopsInteraction.AddToWishlist : FedopsInteraction.RemoveFromWishlist;

    this.fedopsLogger.interactionEnded(fedopsInteraction);
    this.panoramaClient.transaction(fedopsInteraction).finish();

    const eventData = this.createWishlistBiEventData(productId);
    shouldAdd
      ? this.siteStore.webBiLogger.report(productAddedToWishlistSf(eventData))
      : this.siteStore.webBiLogger.report(productRemovedFromWishlistSf(eventData));
  }

  private get categories() {
    return this.categoriesService?.visibleCategories ?? [];
  }

  private fetchFilters(): Promise<FilterModel[]> {
    return this.filtersService.fetchFilters();
  }

  private shouldShowFilters(): boolean {
    const isFiltersEnabledInSomeBreakPoint = this.allStyles?.some(
      (stylesParamsPerBreakpoint) => stylesParamsPerBreakpoint?.galleryShowFilters
    );
    return isFiltersEnabledInSomeBreakPoint && this.filterConfigsService.shouldShowFilters();
  }

  private getNumberOfSelectedFilterTypes() {
    return this.filtersService.getSelectedFilterOptionsCount();
  }

  private hasFilters(): boolean {
    return this.filtersService?.getFilterModels()?.length > 0;
  }

  private sendSortClickBiEvent() {
    this.siteStore.webBiLogger.report(galleryClickSortBy({}));
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public async updateState(
    config: IGalleryControllerConfig,
    newPublicData?: IGalleryControllerConfig['publicData'] & {appSettings?: any}
  ): Promise<void> {
    this.config = config;
    const previousShouldShowProductOptions = this.shouldShowProductOptions;
    const oldStyles = this.styles;
    this.updateStyles();
    this.config.publicData = newPublicData;
    const categoryListConfig = newPublicData?.appSettings?.CATEGORY_LIST_CONFIG;
    /* istanbul ignore next: hard to test, appSettings come from EditorOOI flow */
    if (newPublicData?.appSettings) {
      this.multilingualService.setWidgetSettings(newPublicData.appSettings);
      if (newPublicData.appSettings.FILTERS) {
        this.filterConfigsService.setFilterConfigDTOs(newPublicData.appSettings.FILTERS);
        this.filtersService.deleteFilterModels();
      }
    }

    if (!this.shouldShowFilters()) {
      this.filtersService.deleteFilterModels();
      this.updateComponent({filterModels: []});
    } else if (this.filtersService.getFilterModels().length === 0) {
      const filterModels = await this.filtersService.fetchFilters();
      this.updateComponent({filterModels});
    }

    await this.fetchCategoriesIfNeeded();

    const shouldUpdateCategoryList =
      this.styles.gallery_categoryListStrategy !== oldStyles.gallery_categoryListStrategy || !!categoryListConfig;

    if (shouldUpdateCategoryList) {
      this.categoriesService.updateVisibleCategories({
        categoryListConfig,
        shouldUseCategoryListConfig: this.styles.gallery_categoryListStrategy === CategoryListStrategy.MANUALLY,
      });
    }

    let nextProps: Partial<IPropsInjectedByViewerScript> = {
      isAutoGrid: this.isAutoGrid(),
      loadMoreType: this.loadMoreType(),
      shouldShowAddToCartSuccessAnimation: this.getAddToCartAction() === AddToCartActionOption.NONE,
      hasActiveSortOption: this.hasActiveSortOption(),
      hasFilters: this.hasFilters(),
      textsMap: this.getTextsMap(),
      shouldShowProductOptions: this.shouldShowProductOptions,
      isHorizontalLayout: this.isHorizontalLayout(),
      shouldAlternateImagePosition: this.shouldAlternateImagePosition(),
      imagePosition: this.imagePosition(),
      shouldShowImageCarousel: this.shouldShowImageCarousel,
      maxProductsPerPage: this.maxProductsPerPage,
      totalPages: this.totalPages,
      shouldUseAutoGridProductsCount: this.shouldUseAutoGridProductsCount,
      sortingOptions: this.sortService.updateVisibleSortingOptions(this.styles),
      categories: this.categories,
      useCategories: this.useCategories,
      useSidePanel: this.useSidePanel,
    };

    const shouldUpdateWithOptions = previousShouldShowProductOptions !== this.shouldShowProductOptions;
    const isFixedGridProductsCountChanged =
      this.styles.gallery_fixedGridProductsCount !== oldStyles.gallery_fixedGridProductsCount;
    const isDefaultSortingChanged =
      this.styles.gallery_sortingDefaultOption.value !== oldStyles.gallery_sortingDefaultOption.value;
    const shouldFetchProducts =
      shouldUpdateWithOptions ||
      this.styles.gallery_productsCount !== oldStyles.gallery_productsCount ||
      isDefaultSortingChanged ||
      isFixedGridProductsCountChanged;

    this.productsService.setWithOptions(this.shouldShowProductOptions);

    if (shouldFetchProducts) {
      if (isFixedGridProductsCountChanged) {
        this.setGalleryRows(true);
        this.productsService.setProductsPerPage(this.maxProductsPerPage);
      }

      if (isDefaultSortingChanged) {
        nextProps.selectedSort = this.sortService.setDefaultSortBySettings(
          this.styles.gallery_sortingDefaultOption.value
        );

        this.productsService.updateSort(nextProps.selectedSort);
      }

      const shouldSpecificCollectionQuery = this.filtersService.shouldSpecificCollectionQuery(this.mainCollectionId);
      nextProps.products = await this.productsService.loadProducts({
        from: 0,
        to: this.productsService.getProductPerPage(),
        shouldSpecificCollectionQuery,
      });
      nextProps = {
        ...nextProps,
        maxProductsPerPage: this.maxProductsPerPage,
        productsManifest: this.generateProductsManifest(nextProps.products),
        totalPages: this.totalPages,
      };
    }

    nextProps.productsPriceRangeMap = this.productsService.productPriceRangeMap;
    this.updateComponent({...nextProps, ...this.getCommonPropsToUpdate()});
  }

  private getBICollection() {
    const collectionId = this.productsService.getMainCollectionId();
    return collectionId === this.productsService.allProductsCategoryId ? {} : {categoryId: collectionId};
  }

  private async loadProductsByPage(page: number) {
    const from = this.maxProductsPerPage * (page - 1);
    const to = from + this.maxProductsPerPage;
    const shouldSpecificCollectionQuery = this.filtersService.shouldSpecificCollectionQuery(this.mainCollectionId);
    return this.productsService.loadProducts({
      from,
      to,
      shouldSpecificCollectionQuery,
    });
  }

  /* istanbul ignore next: cannot be easily tested since activating it relies on jsdom having element dimensions */
  private handleCategoryClampClick(isClamped: boolean) {
    return isClamped
      ? this.siteStore.webBiLogger.report(categoryPageHeroSectionReadLessClicked({}))
      : this.siteStore.webBiLogger.report(categoryPageHeroSectionReadMoreClicked({}));
  }

  private handleCategoryBreadcrumbsClick({item, originCategoryId}: {item: BreadcrumbsItem; originCategoryId: string}) {
    return this.siteStore.webBiLogger.report(
      categoryPageBreadcrumbClicked({
        link: item.href,
        originCategoryId,
        destinationCategoryId: item.id.toString(),
      })
    );
  }

  private async handlePaginationBySideEffect() {
    this.fedopsLogger.interactionStarted(FedopsInteraction.Pagination);
    this.panoramaClient.transaction(FedopsInteraction.Pagination).start();
    const products = await this.loadProductsByPage(this.currentPage);
    this.productsService.sendTrackEvent(0);
    await this.setProductItemSlotsProps(products);
    this.veloInputs?.onProductsChanged?.();
    this.updateComponent(this.getComputedProps(products));
    this.fedopsLogger.interactionEnded(FedopsInteraction.Pagination);
    this.panoramaClient.transaction(FedopsInteraction.Pagination).finish();
  }

  private handlePagination(page: number) {
    this.queryParamsService.updatePageQueryParam(page);
    const biCollection = this.biService ? this.biService.getBICollection() : this.getBICollection();
    this.siteStore.webBiLogger.report(clickLoadMoreInGallerySf({...biCollection, type: BiEventParam.Pagination}));
  }

  private readonly preselectCombinedListingDone = new Set<string>();

  private preselectCombinedListingOptions(products: IProduct[]) {
    products
      .filter((product) => this.productGroupsMap[product.id] && !this.preselectCombinedListingDone.has(product.id))
      .forEach((product) => {
        this.preselectCombinedListingDone.add(product.id);

        const singleChoiceSelectionIds = this.getGroupedBySelectionIds(product);

        if (singleChoiceSelectionIds.length) {
          this.productsService.preselectOptionsSync(product.id, singleChoiceSelectionIds);
        }
      });
  }

  private getComputedProps(products: IProduct[]) {
    this.productsManifest = this.generateProductsManifest(products);
    if (this.experiments.enabled(Experiments.CombinedListing)) {
      this.productGroupsMap = this.buildProductGroupsMap(products);
      this.preselectCombinedListingOptions(products);
    }
    return {
      currentPage: this.currentPage,
      scrollToProduct: this.scrollToProduct,
      isFirstPage: false,
      productsManifest: this.productsManifest,
      products,
      promotions: this.promotions,
      totalProducts: this.productsService.totalCount,
      totalPages: this.totalPages,
      productsVariantInfoMap: this.productsVariantInfoMap,
      productsPriceRangeMap: this.productsService.productPriceRangeMap,
      shouldShowImageCarousel: this.shouldShowImageCarousel,
      isGalleryRowsAndColsWereModified: this.isGalleryRowsAndColsWereModified,
      productGroupsMap: this.productGroupsMap,
      handleCombinedListingSiblingSwitch: this.handleCombinedListingSiblingSwitch.bind(this),
    };
  }

  private buildProductGroupsMap(products: IProduct[]): {[productId: string]: IProductGroup} {
    return Object.fromEntries(
      products
        .filter((p) => p.groupInfo?.productGroupId && p.groupInfo.groupingCustomizationId)
        .map((p) => [p.id, this.buildProductGroup(p)])
    );
  }

  private buildProductGroup(product: IProduct): IProductGroup {
    const {groupInfo} = product;

    /* istanbul ignore next: caller filters for products with groupInfo */
    const members = groupInfo?.members ?? [];
    const assignments: IProductGroupAssignment[] = members.map((member, idx) => ({
      productId: member.productId,
      choice: {
        id: String(idx + 1),
        name: member.choice?.description ?? '',
        value: member.choice?.value ?? '',
      },
      slug: member.slug ?? '',
      stockStatus: member.inventoryAvailabilityStatus !== 'OUT_OF_STOCK' ? 'IN_STOCK' : 'OUT_OF_STOCK',
      status: 'ACTIVE',
    }));

    return {
      id: groupInfo?.productGroupId,
      customizationId: groupInfo?.groupingCustomizationId,
      choiceOrdering: assignments.map((a) => a.choice.id),
      assignments,
    };
  }

  private shouldUsePromotionCards(): boolean {
    return (
      this.experiments.enabled(Experiments.ShowPromotionsInGallery) &&
      [StoresWidgetID.GRID_GALLERY, StoresWidgetID.CATEGORY_PAGE].includes(this.type as StoresWidgetID)
    );
  }

  private readonly isResponsive = () => {
    return this.styles.responsive === true;
  };

  private readonly isAutoGrid = () => {
    if (this.siteStore.isMobile() && !this.isResponsive()) {
      return false;
    }

    return this.styles.gallery_gridType === GridType.AUTO;
  };

  private get shouldUseAutoGridProductsCount() {
    return this.styles.gallery_gridType === GridType.AUTO;
  }

  private getPaginationMode(): PaginationTypeName {
    const paginationFormat = this.styles.gallery_paginationFormat;

    return this.siteStore.isMobile() || paginationFormat === PaginationType.COMPACT ? 'compact' : 'pages';
  }

  private setTaxonomicalBreadcrumbs() {
    const breadcrumbs = this.currentCategory.breadcrumbsInfo?.breadcrumbs?.map((b) => ({
      id: b.categoryId,
      value: b.categoryName,
      href: `${this.siteStore.location.baseUrl}/${RouterPrefix.CATEGORY}/${b.categorySlug}`,
    }));

    this.taxonomicalBreadcrumbsItems = [
      {
        id: 'home',
        value: this.translations['gallery.breadcrumbs.firstItem'],
        href: this.siteStore.location.baseUrl,
      },
      ...(breadcrumbs || []),
      {
        id: this.currentCategory.id,
        value: this.currentCategory.name,
        href: '',
      },
    ];
  }

  private readonly setBreadcrumbsHistory = () => {
    this.breadcrumbsItems = [
      {id: 'home', href: this.homepageUrl, value: this.translations['gallery.breadcrumbs.firstItem']},
      {
        id: this.currentCategory.id,
        href: '',
        value:
          this.currentCategory.name === 'All Products' ? this.getTextsMap().allProducts : this.currentCategory.name,
      },
    ];
  };

  protected get stylesParams() {
    switch (this.type) {
      case StoresWidgetID.CATEGORY_PAGE:
        return categoryStylesParams;
      case StoresWidgetID.SEARCH_MODAL_GALLERY:
        return searchModalPageStylesParams;
      case StoresWidgetID.SEARCH_RESULTS_GALLERY:
        return searchResultsPageStylesParams;
      default:
        return gridGalleryStylesParams;
    }
  }

  private get shouldQueryCurrencyRate() {
    return this.isUsingAlternativeCurrency;
  }

  private get isShowErrorHandlingToastsGalleryEnabled() {
    return this.experiments.enabled(Experiments.ShowErrorHandlingToastsGallery);
  }

  /* istanbul ignore next */
  private get errorHandler() {
    return this.isShowErrorHandlingToastsGalleryEnabled ? this.flowAPI.errorHandler : undefined;
  }

  private readonly reportWidgetLoadedPanorama = () => {
    const event = widgetLoadedPanoramaEventMap[this.type];
    if (event) {
      this.panoramaClient.transaction(event).finish();
    }
  };
}
